import * as v from "valibot";
import { rpcContract } from "../rpc";

export const updateLiveEventRpcContract = rpcContract({
  name: "update-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
    title: v.optional(
      v.pipe(
        v.string(),
        v.minLength(1, "Title is required"),
        v.maxLength(255, "Title must be less than 255 characters"),
      ),
    ),
    description: v.optional(v.pipe(v.string(), v.maxLength(750, "Description must be less than 750 characters"))),
    content_tier: v.optional(v.picklist(["free", "premium"])),
    fee_cents: v.optional(
      v.nullable(
        v.pipe(v.number(), v.minValue(50, "Fee must be at least €0.50"), v.maxValue(99900, "Fee cannot exceed €999")),
      ),
    ),
    scheduled_start_time: v.optional(v.pipe(v.string(), v.isoTimestamp("Invalid date format"))),
    max_attendees: v.optional(
      v.nullable(
        v.pipe(
          v.number(),
          v.minValue(1, "Max attendees must be at least 1"),
          v.maxValue(10000, "Max attendees cannot exceed 10,000"),
        ),
      ),
    ),
    thumbnail_file_id: v.optional(v.nullable(v.string())),
    whatsapp_url: v.optional(v.nullable(v.string())),
    post_buying_video_file_id: v.optional(v.nullable(v.string())),
    cta_text: v.optional(v.nullable(v.pipe(v.string(), v.maxLength(255, "CTA text must be less than 255 characters")))),
    language: v.optional(
      v.nullable(v.pipe(v.string(), v.maxLength(10, "Language code must be less than 10 characters"))),
    ),
    stream_delivery: v.optional(v.picklist(["browser", "obs"], "Stream delivery must be browser or obs")),
    expected_duration: v.optional(
      v.nullable(
        v.pipe(
          v.number(),
          v.minValue(1, "Duration must be at least 1 minute"),
          v.maxValue(1440, "Duration cannot exceed 24 hours"),
        ),
      ),
    ),
    link_ids: v.optional(v.nullable(v.array(v.string()))),
    community_only: v.optional(v.boolean()),
    community_ids: v.optional(v.array(v.string())),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    event: v.optional(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        content_tier: v.string(),
        fee_cents: v.nullable(v.number()),
        status: v.string(),
        scheduled_start_time: v.string(),
        max_attendees: v.nullable(v.number()),
        thumbnail_url: v.nullable(v.string()),
        updated_at: v.string(),
        expected_duration: v.nullable(v.number()),
      }),
    ),
    message: v.optional(v.string()),
  }),
});

export type UpdateLiveEventParams = v.InferOutput<(typeof updateLiveEventRpcContract)["paramsSchema"]>;
export type UpdateLiveEventResult = v.InferOutput<(typeof updateLiveEventRpcContract)["resultSchema"]>;
